var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
var VentanaEstatica = (_temp = _class = function (_Component) {
  _inherits(VentanaEstatica, _Component);

  function VentanaEstatica(props) {
    _classCallCheck(this, VentanaEstatica);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.triggerOnResize = function () {
      var _this$ventanaRef$curr = _this.ventanaRef.current.getBoundingClientRect(),
          width = _this$ventanaRef$curr.width,
          height = _this$ventanaRef$curr.height;

      _this.setState({
        width: width,
        height: height
      }, function () {
        var onResize = _this.props.onResize;
        onResize && onResize(width, height);
      });
    };

    _this.handleAnimationEnd = function (e) {
      if (_this.props.abierta) {
        _this.setState({
          visible: true
        });

        return;
      }

      _this.setState({
        visible: false
      });
    };

    _this.state = {
      visible: false,
      // cerrada y animación terminada
      width: null,
      height: null,
      anchoEnPorcentaje: "100%",
      altoEnPorcentaje: "100%",
      resizing: false,
      ajuste: props.ajusteInicial
    };
    _this.ventanaRef = React.createRef();
    return _this;
  }

  VentanaEstatica.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.triggerOnResize);
    this.triggerOnResize();
  };

  VentanaEstatica.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.triggerOnResize);
  };

  VentanaEstatica.prototype.construirEstilo = function construirEstilo() {
    var _props = this.props,
        ancho = _props.ancho,
        alto = _props.alto;
    var ajuste = this.state.ajuste;
    var style = {
      width: ancho,
      height: alto
    };

    if (!this.props.abierta && !this.state.visible) {
      style.position = "absolute";
      style.top = "-9999px";
      style.left = "-9999px";
      return;
    }

    if (ajuste === 'contenido') {
      style.maxWidth = '90%';
      style.maxHeight = '80%';
      style.width = ancho;
      style.height = alto;
    }

    return style;
  };

  VentanaEstatica.prototype.render = function render() {
    var _props2 = this.props,
        id = _props2.id,
        abierta = _props2.abierta;
    var style = this.construirEstilo();
    var clases = [this.props.clases, 'ventana', abierta ? 'abierta' : 'cerrada'].join(' ');
    var clasesExtra = this.props.clasesExtra ? ' ' + this.props.clasesExtra : '';
    return React.createElement('div', {
      id: id,
      className: clases + clasesExtra,
      style: style,
      ref: this.ventanaRef,
      onAnimationEnd: this.handleAnimationEnd
    }, this.props.children);
  };

  return VentanaEstatica;
}(Component), _class.defaultProps = {
  clases: '',
  clasesExtra: '',
  tieneAnimacion: true,
  abierta: false,
  ancho: '100%',
  alto: '100%',
  ajusteInicial: 'fijo'
}, _temp);
VentanaEstatica.propTypes = process.env.NODE_ENV !== "production" ? {
  clases: t.string,
  clasesExtra: t.string,
  tieneAnimacion: t.bool.isRequired,
  ancho: t.oneOfType([t.string, t.number]),
  // opcional
  alto: t.oneOfType([t.string, t.number]),
  // opcional
  abierta: t.bool,
  onResize: t.func,
  id: t.string,
  children: t.any,
  ajusteInicial: t.string
} : {};
export default VentanaEstatica;